"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    document.body.appendChild(notification);
    notification.classList.add("notification", type);
    var createTitle = document.createElement("h2");
    createTitle.textContent = title;
    createTitle.classList.add("title");
    var createDescription = document.createElement("p");
    createDescription.textContent = description;
    notification.appendChild(createTitle);
    notification.appendChild(createDescription);
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.9f8b30fc.js.map
